module.exports = __webpack_public_path__ + "static/media/splash-screen-logo.6b9fb27c.png";